let audioUrl = ""
let audio = null
let isPlaying = false

// Import the data to customize and insert them into page
const fetchData = () => {
  fetch("customize.json")
    .then(data => data.json())
    .then(data => {
      dataArr = Object.keys(data)
      dataArr.map(customData => {
        if (data[customData] !== "") {
          if (customData === "imagePath") {
            document
              .querySelector(`[data-node-name*="${customData}"]`)
              .setAttribute("src", data[customData])
          } else if (customData === "fonts") {
            data[customData].forEach(font => {
              // Create @font-face rule for custom fonts
              const style = document.createElement('style')
              style.textContent = `
                @font-face {
                  font-family: '${font.name}';
                  src: url('${font.path}') format('opentype');
                  font-weight: normal;
                  font-style: normal;
                }
              `
              document.head.appendChild(style)
              // Apply font to body
              document.body.style.fontFamily = `'${font.name}', sans-serif`
            })
          } else if (customData === "music") {
            audioUrl = data[customData]
            audio = new Audio(audioUrl)
            audio.preload = "auto"
          } else {
            document.querySelector(`[data-node-name*="${customData}"]`).innerText = data[customData]
          }
        }

        // Check if the iteration is over
        // Run amimation if so
        if (dataArr.length === dataArr.indexOf(customData) + 1) {
          document.querySelector("#startButton").addEventListener("click", () => {
            document.querySelector(".startSign").style.display = "none"
            animationTimeline()
          }
          )
          // animationTimeline()
        }
      })
    })
}

// Animation Timeline
const animationTimeline = () => {
  // Spit chars that needs to be animated individually
  const textBoxChars = document.getElementsByClassName("hbd-chatbox")[0]
  const hbd = document.getElementsByClassName("wish-hbd")[0]

  textBoxChars.innerHTML = `<span>${textBoxChars.innerHTML
    .split("")
    .join("</span><span>")}</span`

  hbd.innerHTML = `<span>${hbd.innerHTML
    .split("")
    .join("</span><span>")}</span`

  const tl = new TimelineMax()

  tl
    .to(".container", 0.1, {
      visibility: "visible"
    })
    .from(".one", 0.7, {
      opacity: 0,
      y: 10
    })
    .from(".two", 0.4, {
      opacity: 0,
      y: 10
    }, "+=1")
    .to(
      ".one",
      0.7,
      {
        opacity: 0,
        y: 10
      },
      "+=2.5"
    )
    .to(
      ".two",
      0.7,
      {
        opacity: 0,
        y: 10
      },
      "-=1"
    )
    .from(".date-section", 0.7, {
      opacity: 0,
      y: 10
    })
    .add(() => {
      // Slot machine date randomization effect
      const dayEl = document.querySelector('.date-countdown .date-day');
      const monthEl = document.querySelector('.date-countdown .date-month');
      const yearEl = document.querySelector('.date-countdown .date-year');
      const dateWrapper = document.querySelector('.date-countdown');
      
      // Date data arrays
      const days = Array.from({length: 31}, (_, i) => i + 1);
      const months = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 
                      'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
      const years = [2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030];
      
      // Target date
      const targetDay = 9;
      const targetMonth = 'Februari';
      const targetYear = 2026;
      
      const duration = 5000; // 5 seconds
      const interval = 50; // Update every 50ms for smooth effect
      const startTime = Date.now();
      
      // Randomize function
      const randomize = (arr) => arr[Math.floor(Math.random() * arr.length)];
      
      const rollInterval = setInterval(() => {
        const elapsed = Date.now() - startTime;
        const progress = elapsed / duration;
        
        if (progress < 1) {
          // Still randomizing - slow down gradually
          dayEl.textContent = randomize(days);
          monthEl.textContent = randomize(months);
          yearEl.textContent = randomize(years);
        } else {
          // Stop at target date
          clearInterval(rollInterval);
          dayEl.textContent = targetDay;
          monthEl.textContent = targetMonth;
          yearEl.textContent = targetYear;
          
          TweenMax.to(dateWrapper, 0.7, {
            scale: 1.2,
            backgroundColor: "rgb(250, 2, 2)",
            color: "#fff",
            delay: 0.3
          });
        }
      }, interval);
    })
    .to(".date-section", 0.7, {
      opacity: 0,
      y: 10
    }, "+=8")
    .from(".three", 0.7, {
      opacity: 0,
      y: 10
      // scale: 0.7
    })
    .to(
      ".three",
      0.7,
      {
        opacity: 0,
        y: 10
      },
      "+=2"
    )
    .from(".four", 0.7, {
      scale: 0.2,
      opacity: 0
    })
    .from(".fake-btn", 0.3, {
      scale: 0.2,
      opacity: 0
    })
    .staggerTo(
      ".hbd-chatbox span",
      1,
      {
        visibility: "visible"
      },
      0.05
    )
    .to(".fake-btn", 0.1, {
      backgroundColor: "#8FE3B6"
    })
    .to(
      ".four",
      0.5,
      {
        scale: 0.2,
        opacity: 0,
        y: -150
      },
      "+=1.2"
    )
    .from(".idea-1", 0.7,       
      {
        opacity: 0,
        y: 10
      })
    .to(".idea-1", 0.7, 
      {
        opacity: 0,
        y: 10
      }, "+=2")
    .from(".bdayCake", 0.7,       
      {
        opacity: 0,
        y: 10
      })
    .from(".idea-2", 0.7, 
      {
        opacity: 0,
        y: 10
      }, "+=1.5")
    .to(".flame", 0.7, {
      opacity: 0
    }, "+=1.5")
    .add(() => {
      document.querySelector('.candle').classList.add('flame-out');
    }, "-=0.7")
    .to(".idea-2", 0.7,
            {
        opacity: 0,
        y: 10
      })
    .to(".bdayCake", 0.7, 
      {
        opacity: 0,
        y: 10
      }, "+=2")
    .from(".idea-4", 0.7, 
      {
      opacity: 0,
      y: 10
    })
    .to(".idea-4", 0.7,
      {
        opacity: 0,
        y: 10
      }, "+=2")
    .from(
      ".idea-5",
      0.7,
      {
        y: 50,
        opacity: 0
      },
      "+=1"
    )
    .to(
      ".idea-5",
      0.7,
      {
        y: 50,
        opacity: 0
      },
      "+=1"
    )
    .to(
      ".idea-5",
      0.7,
      {
        scale: 0.2,
        opacity: 0
      }
    )
    .staggerFromTo(
      ".baloons img",
      4.5,
      {
        opacity: 0.9,
        y: 1400
      },
      {
        opacity: 1,
        y: -1000
      },
      0.2
    )
    .from(
      ".lydia-dp",
      0.5,
      {
        scale: 3.5,
        opacity: 0,
        x: 25,
        y: -25,
        rotationZ: -45
      },
      "-=2"
    )
    .from(".hat", 0.5, {
      x: -100,
      y: 350,
      rotation: -180,
      opacity: 0
    })
    .staggerFrom(
      ".wish-hbd span",
      0.7,
      {
        opacity: 0,
        y: -50,
        rotation: 150,
        skewX: "30deg",
        ease: Elastic.easeOut.config(1, 0.5)
      },
      0.1
    )
    .staggerFromTo(
      ".wish-hbd span",
      0.7,
      {
        scale: 1.4,
        rotationY: 150
      },
      {
        scale: 1,
        rotationY: 0,
        color: "#ff69b4",
        ease: Expo.easeOut
      },
      0.1,
      "party"
    )
    .from(
      ".wish h5",
      0.5,
      {
        opacity: 0,
        y: 10,
        skewX: "-15deg"
      },
      "party"
    )
    // .add(() => tl.pause())
    .staggerTo(
      ".eight svg",
      1.5,
      {
        visibility: "visible",
        opacity: 0,
        scale: 70,
        repeat: 3,
        repeatDelay: 3
      },
      0.3
    )
    .to(".six", 0.5, {
      opacity: 0,
      y: 30,
      zIndex: "-1"
    }, "+=1")
    .staggerFrom(".nine p", 0.7,
      {
        opacity: 0,
        y: 10
      }, 
    "+=1")

  // tl.seek("currentStep");
  // tl.timeScale(2);

  // Restart Animation on click
  const replyBtn = document.getElementById("replay")
  replyBtn.addEventListener("click", () => {
    // Reset elements to initial state before replay
    const dateWrapperEl = document.querySelector('.date-countdown');
    const dayEl = document.querySelector('.date-countdown .date-day');
    const monthEl = document.querySelector('.date-countdown .date-month');
    const yearEl = document.querySelector('.date-countdown .date-year');
    const candleEl = document.querySelector('.candle');
    const flameEl = document.querySelector('.flame');
    
    // Reset date countdown styles
    if (dateWrapperEl) {
      TweenMax.set(dateWrapperEl, {
        scale: 1,
        backgroundColor: "#FFFFFF",
        color: "#000000"
      });
    }
    
    // Reset date values
    if (dayEl) dayEl.textContent = '';
    if (monthEl) monthEl.textContent = '';
    if (yearEl) yearEl.textContent = '';
    
    // Reset candle flame
    if (candleEl) candleEl.classList.remove('flame-out');
    if (flameEl) TweenMax.set(flameEl, { opacity: 1 });
    
    tl.restart();

  })
}

// Run fetch and animation in sequence
fetchData()

const playPauseButton = document.getElementById('playPauseButton')

document.getElementById('startButton').addEventListener('click', () => {
  if (audio) {
    togglePlay(true)
  }
})

playPauseButton.addEventListener('click', () => {
  if (audio) {
    togglePlay(!isPlaying)
  }
})

function togglePlay(play) {
  if (!audio) return
  
  isPlaying = play
  play ? audio.play() : audio.pause()
  playPauseButton.classList.toggle('playing', play)
}